import { Ref } from 'vue';
import { keepPreviousData, useInfiniteQuery, useMutation, useQuery } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { useHeaderStore } from '@/stores/header';
import { ApiError, CommonResType } from '@/types/commonApiType';

import { api } from './_http';
import { MonthlyCapture } from './master';
// 대가의 타이밍 리스트 조회

export type GetBookmarksData = {
	bookmarks: bookmarks[];
	count: number;
};
export type bookmarks = {
	bookmarks: number;
	event_name: string;
	event_pk: number;
	master_name: string;
	master_pk: number;
	master_investment_score: number;
	master_investment_pk: number;
};
export const useGetBookmarksApi = () => {
	const url = '/v1/front/getBookmarks';
	return useInfiniteQuery<{ data: GetBookmarksData }, AxiosError, GetBookmarksData, [string], number>({
		queryKey: [url],
		queryFn: async ({ pageParam = 1 }) => {
			const res = await api.get<AxiosResponse<GetBookmarksData>>(url, { page: pageParam });
			return res.data;
		},
		initialPageParam: 1,
		getNextPageParam: (lastPage: { data: GetBookmarksData }, allPages: { data: GetBookmarksData }[]) => {
			const totalItem = lastPage.data.count;
			const currentItem = allPages.length * 5;
			return totalItem > currentItem ? allPages.length + 1 : undefined;
		},
		select: (res) => {
			const bookmarksList = res.pages.reduce<bookmarks[]>((prev, cur) => {
				return cur.data.bookmarks ? [...prev, ...cur.data.bookmarks] : [];
			}, []);

			return {
				count: res.pages[0].data.count ?? 0,
				bookmarks: bookmarksList,
			};
		},
		placeholderData: keepPreviousData,
	});
};

//즐겨찾기 분석
type GetInvestmentReportParams = {
	stock: string;
	master: string;
	score: number;
};
export type GetInvestmentReportData = {
	master_investment_pk: number;
}[];
export const useGetInvestmentReportApi = (params: GetInvestmentReportParams) => {
	const url = '/v1/front/getInvestmentReport';
	return useQuery<AxiosResponse, AxiosError, GetInvestmentReportData>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => {
			return res.data?.data;
		},
		enabled: false,
	});
};

// 즐겨찾기 액션
export type AdjustBookmarks = {
	event_pk: number | string;
	master_investment_pk?: number | string;
	master_pk?: number | string | null;
};
type AdjustBookmarksDataType = {
	bookmarks: AdjustBookmarks[];
};
type AdjustBookmarksResType = CommonResType;
export const useAdjustBookmarksApi = () => {
	const headerStore = useHeaderStore();
	const url = '/v1/front/adjustBookmarks';
	return useMutation<AxiosResponse<AdjustBookmarksResType>, AxiosError, AdjustBookmarksDataType>({
		mutationFn: (data: AdjustBookmarksDataType) => api.post(url, { ...data, country: headerStore.getCountry }),
	});
};

// ETF 즐겨찾기 액션
export type AdjustEtfBookmarks = {
	etf_event_pk: number | string;
	color: string;
};

type AdjustEtfBookmarksResType = CommonResType;
export const useEtfAdjustBookmarksApi = () => {
	const url = '/v1/front/usa/adjustEtfBookmarks';
	return useMutation<AxiosResponse<AdjustEtfBookmarksResType>, AxiosError, AdjustEtfBookmarks>({
		mutationFn: (data: AdjustEtfBookmarks) => api.post(url, { ...data }),
	});
};
//------------------------------------------------------------------------------------
//미국주식

export type GetBookmarksUSAParams = Ref<{
	tab: string;
}>;
export type GetBookmarksUSAData = {
	bookmarks: MonthlyCapture[];
	count: number;
};

export const useGetBookmarksUSAInfiniteApi = (params: GetBookmarksUSAParams) => {
	const url = '/v1/front/usa/getBookmarks';
	return useInfiniteQuery<
		{ data: GetBookmarksUSAData },
		ApiError,
		GetBookmarksUSAData,
		[string, GetBookmarksUSAParams]
	>({
		queryKey: [url, params],
		queryFn: async ({ pageParam = 1 }) => {
			const res = await api.get<AxiosResponse<GetBookmarksUSAData>>(url, { tab: params.value.tab, page: pageParam });
			return res.data;
		},
		initialPageParam: 1,
		getNextPageParam: (lastPage: { data: GetBookmarksUSAData }, allPages: { data: GetBookmarksUSAData }[]) => {
			const totalItem = lastPage.data.count;
			const currentItem = allPages.length * 5;
			return totalItem > currentItem ? allPages.length + 1 : undefined;
		},
		select: (res) => {
			const bookmarksList = res.pages.reduce<MonthlyCapture[]>((prev, cur) => {
				return cur.data.bookmarks ? [...prev, ...cur.data.bookmarks] : [];
			}, []);

			return {
				count: res.pages[0].data.count ?? 0,
				bookmarks: bookmarksList,
			};
		},
		placeholderData: keepPreviousData,
	});
};

//------------------------------------------------------------------------------------
//일본주식

export const useGetBookmarksJPNInfiniteApi = () => {
	const url = '/v1/front/jpn/getBookmarks';
	return useInfiniteQuery<{ data: GetBookmarksUSAData }, ApiError, GetBookmarksUSAData, [string]>({
		queryKey: [url],
		queryFn: async ({ pageParam = 1 }) => {
			const res = await api.get<AxiosResponse<GetBookmarksUSAData>>(url, { page: pageParam });
			return res.data;
		},
		initialPageParam: 1,
		getNextPageParam: (lastPage: { data: GetBookmarksUSAData }, allPages: { data: GetBookmarksUSAData }[]) => {
			const totalItem = lastPage.data.count;
			const currentItem = allPages.length * 5;
			return totalItem > currentItem ? allPages.length + 1 : undefined;
		},
		select: (res) => {
			const bookmarksList = res.pages.reduce<MonthlyCapture[]>((prev, cur) => {
				return cur.data.bookmarks ? [...prev, ...cur.data.bookmarks] : [];
			}, []);

			return {
				count: res.pages[0].data.count ?? 0,
				bookmarks: bookmarksList,
			};
		},
		placeholderData: keepPreviousData,
	});
};
